import React from "react";
import axiosInstance from "../axiosConfig";
import { encryptData } from "../../utils/jose";

class MyAccountService extends React.Component {
  getUserDetails = async ({ queryKey }) => {
    const [_key, { user_id }] = queryKey;
    return await axiosInstance.post(`api/user_details`);
  };

  changePasswordService = async (payload) => {
    const getKeys = await axiosInstance.post(`/api/hand-shake-for-keys`);
    if(getKeys?.status_code !== 200) return;
    
    const publicKey = atob(getKeys?.server_public_key);
    return await axiosInstance.post(`/api/change-password`, {
      old_password: await encryptData(payload?.currentPassword, publicKey),
      password: await encryptData(payload?.newPassword, publicKey),
      password_confirmation: await encryptData(payload?.confirmPassword, publicKey),
    });
  };

  updateDetailsMyAccount = async (payload) => {
    return await axiosInstance.post(
      `/api/update-my-account`,
      {
        name: payload?.fullName,
        email: payload?.email,
        mobile_no: payload?.phone,
        whatsapp_status: payload?.whatsapp_status,
      }
    );
  };

  uploadProfilePic = async (payload) => {
    return await axiosInstance.post(
      `/api/update-my-account`,
      {
        image: payload?.imageSrc,
      },
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
  };

  deleteProfilePic = async (payload) => {
    return await axiosInstance.post(
      `/api/delete-profile-image`
    );
  };
}

const instance = new MyAccountService();

export default instance;
